import ModelUpdate from "@/models/ModelUpdate";
import {IGlobalConfigAdmin} from "@/models/global-config/GlobalConfigAdminModels";
import {ValidationRule} from "@/declarations/ValidationRule";

export default class GlobalConfigUpdateTrimmingCost extends ModelUpdate<IGlobalConfigAdmin> {

	public trimmingCostThreshold!: number | null;
	public trimmingCostPrice!: number | null;

	public constructor(model: IGlobalConfigAdmin) {
		super();
		this.setDetailModel(model);
	}

	protected initializeWithDetailModelData(detailModel: IGlobalConfigAdmin): void {
		this.trimmingCostThreshold = detailModel.trimmingCostThreshold ?? null;
		this.trimmingCostPrice = detailModel.trimmingCostPrice?.amount ?? null;
	}

	public rules(): ValidationRule[] {
		return [];
	}

}
